import React from 'react';
import { SortOrder } from 'services/sort';

const SortIcon = ({ active, order }: any) => {
    if (!active || !order) {
        return <div className="icon-flechas" />;
    }
    if (order === 'asc') {
        return <div className="icon-flechas1" />;
    }
    return <div className="icon-flechas2" />;
};

export interface Sortable {
    active: boolean;
    order: SortOrder;
    property: string;
    isLoading: boolean;
    disabled: boolean;
    onSort: (property: string, order: SortOrder) => void;
}

export interface SortableColumnProps {
    label: string;
    sortable?: Sortable;
}

export const SortableColumn = (props: SortableColumnProps) => {
    if (!props.sortable) {
        return (
            <th className="page-container--table-head-title hand">
                <span>{props.label}</span>
            </th>
        );
    }

    const { active, order, property, isLoading, disabled, onSort } = props.sortable;

    const handleSort = () => {
        if (!isLoading && !disabled) {
            onSort(property, order);
        }
    };

    return (
        <th className="page-container--table-head-title hand" onClick={handleSort}>
            <span>{props.label}</span>
            <span className="page-container--table-head-arrow">
                <SortIcon active={active} order={order} />
            </span>
        </th>
    );
};

export default SortableColumn;
